import { t } from "i18next"

export function getRowDisplayConditions() {
    return [
        {
            type: t("app-designer-editors-condition-contact-language"),
            label: t("app-general-languages_en-US-translated"),
            description: t(
                "app-designer-editors-condition-contact-language-desc",
                {
                    // eslint-disable-next-line quotes
                    ISOCodes: '"en_US" ' + t("app-general_or") + ' "en" ',
                }
            ),
            // eslint-disable-next-line quotes
            before: '[IF `language` = "en_US" OR `language` = "en" ]',
            after: "[ENDIF]",
        },
        {
            type: t("app-designer-editors-condition-contact-language"),
            label: t("app-general-languages_fr-CA-translated"),
            description: t(
                "app-designer-editors-condition-contact-language-desc",
                {
                    // eslint-disable-next-line quotes
                    ISOCodes: '"fr_CA" ' + t("app-general_or") + ' "fr" ',
                }
            ),
            // eslint-disable-next-line quotes
            before: '[IF `language` = "fr_CA" OR `language` = "fr" ]',
            after: "[ENDIF]",
        },
        {
            type: t("app-designer-editors-condition-contact-language"),
            label: t("app-general-languages_not_en-US"),
            description: t(
                "app-designer-editors-condition-contact-not-language-desc",
                {
                    // eslint-disable-next-line quotes
                    ISOCodes: '"en_US" ' + t("app-general-and") + ' "en" ',
                }
            ),
            // eslint-disable-next-line quotes
            before: '[IF `language` != "en_US" AND `language` != "en" ]',
            after: "[ENDIF]",
        },
        {
            type: t("app-designer-editors-condition-contact-language"),
            label: t("app-general-languages_not_fr-CA"),
            description: t(
                "app-designer-editors-condition-contact-not-language-desc",
                {
                    // eslint-disable-next-line quotes
                    ISOCodes: '"fr_CA" ' + t("app-general-and") + ' "fr" ',
                }
            ),
            // eslint-disable-next-line quotes
            before: '[IF `language` != "fr_CA" AND `language` != "fr" ]',
            after: "[ENDIF]",
        },
    ]
}